function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.544 15.8h-.045a.624.624 0 0 1-.57-.728l.848-4.939L.189 6.629a.624.624 0 0 1 .346-1.066l4.959-.721L7.711.348a.625.625 0 0 1 1.121 0l2.217 4.494 4.959.721a.623.623 0 0 1 .414.248.612.612 0 0 1 .113.461.631.631 0 0 1-.181.358l-3.588 3.5.847 4.939a.624.624 0 0 1-.906.658l-4.436-2.334-4.435 2.331a.621.621 0 0 1-.292.076zM8.271 2.391 6.428 6.127l-4.125.6 2.984 2.91-.7 4.108L8.271 11.8l3.689 1.937-.705-4.108 2.985-2.902-4.125-.6-1.844-3.736z",
    transform: "translate(1.729 1.334)",
    style: {
      fill: "#d9d9d9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.eba5d9bf920582cab2a174888c75b004.svg";
export { ForwardRef as ReactComponent };